import React, { useState } from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { HorizontalStack } from '@ztechapps/webui.util'
import { NO_EDIT_PERMISSION_REASON } from '../../PermissionReasons'
import { BlogCategoryNameModal } from './BlogCategoryNameModal'
import { useBlogCategoryTreeViewContext } from './Context'

enum ToolbarModalEnum {
  AddCategory = 'AddCategory',
  AddSubCategory = 'AddSubCategory',
}

export const BlogCategoryToolbar = () => {
  const { selectedBlogCategory, canEdit, addBlogCategory } = useBlogCategoryTreeViewContext()
  const [modal, setModal] = useState<ToolbarModalEnum>()
  const _id = selectedBlogCategory?._id
  const name = selectedBlogCategory?.name ?? ''

  return (
    <>
      <HorizontalStack gap={2} className="flex-wrap">
        <BusyButton
          icon="plus"
          text="Add category"
          bsSize="sm"
          disabledReason={canEdit ? undefined : NO_EDIT_PERMISSION_REASON}
          onClick={() => setModal(ToolbarModalEnum.AddCategory)}
        />
        <BusyButton
          icon="plus"
          text="Add sub-category"
          bsSize="sm"
          variant="outline-secondary"
          disabledReason={
            canEdit ? (selectedBlogCategory ? undefined : 'Select a category first.') : NO_EDIT_PERMISSION_REASON
          }
          onClick={() => setModal(ToolbarModalEnum.AddSubCategory)}
        />
      </HorizontalStack>

      <BlogCategoryNameModal
        show={modal === ToolbarModalEnum.AddCategory}
        title="Add a category"
        onSave={(newName) => addBlogCategory(newName, null)}
        onClose={() => setModal(undefined)}
      />
      <BlogCategoryNameModal
        show={modal === ToolbarModalEnum.AddSubCategory}
        title={`Add a sub-category to ${name}`}
        onSave={(newName) => addBlogCategory(newName, _id)}
        onClose={() => setModal(undefined)}
      />
    </>
  )
}
